<template>
    <div class="Politique">
        <HeadPageImage :title="'Politique de confidentialité'"
                        class="updateIconPolitique"
                       :subTitle="'Dernière mise à jour le 22/06/2021'"
                       :icon1="'cookie/cogwheel.svg'" :altIcon1="'Decoration SMS'"
                       :icon2="'cookie/cookieGreen.svg'" :altIcon2="'Decoration Letter'"
                       :img1="'cookie/security.jpg'" :altImg1="'Decoration security'"
                       :img2="'cookie/privacy2.jpg'" :altImg2="'Decoration privacy2'"
                       :img3="'cookie/security2.jpg'" :altImg3="'Decoration security2'"
                       :img4="'cookie/privacy.jpg'" :altImg4="'Decoration privacy'"
        />
        <div class="Politique-Container-Text">
            <p>En poursuivant votre navigation sur ce site, vous acceptez l'utilisation de cookies pour 
                réaliser des statistiques de navigation.</p>
                    <p class="bold">Nature des données recueillies</p>
                    <p>Dans un soucis de respect de la vie privée de ses utilisateurs, la société <strong>JobStream</strong> s'engage à ce 
            que la collecte et le traitement des données réalisés par le présent site, soient conformes à la RGPD
            et à la loi n°78-17 du 6 janvier 1978 relative à l'informatique, aux fichiers et aux libertés.
            </p>
            <p>A ce titre, la société <strong>JobStream</strong> fait l'objet d'une déclaration simplifiée auprès de la CNIL.</p>
            <p>Les informations que nous recueillons se limitent :</p>
                    <ul>
                        <li>A un suivi de votre navigation sur notre site, uniquement si vous avez préalablement permis à 
            <strong>JobStream</strong> de recueillir vos données personnelles.
            </li>
                        <li>Aux informations personnelles que vous avez volontairement enregistrées lors de votre inscription
            auprès du cabinet par inscription sur notre site via formulaire.</li>
                    </ul>
                    <p class="bold">Finalité de la collecte et du traitement</p>
                    <p>Votre navigation sur le site fait l'objet d'un traitement. Ce traitement se rapporte à un suivi de la 
            manière dont vous évoluez sur notre site et les pages que vous visitez, exclusivement à des 
            fins commerciales.
            </p>
                    <p>Ce dispositif permet de vous proposer du contenu personnalisé grâce à l'installation de cookies.
            Ces cookies permettent de vous identifier au moyen des informations que vous nous avez 
            sciemment communiquées.
            </p>
                    <p>L'intégralité des données personnelles ne fait l'objet d'aucun transfert.</p>
        </div>
    </div>
</template>

<script>
import HeadPageImage from '../global/HeadPageImage.vue'

export default {
    name: "Politique",
    components: {
        HeadPageImage
    }
}
</script>

<style scoped> 
/* 
*   Global
*/
.Politique-Container-Text {
    width: 70%;
    margin: auto;
    padding: 50px;
}

p, li {
    font-size: 14px;
    margin-bottom: 20px;
}

.bold {
    font-weight: bolder;
    margin-bottom: 5px;
}

ul {
    list-style-image: url('/img/global/dot.svg');
}

@media (max-width: 600px) {
    .Politique-Container-Text {
        padding: 40px;
    }
}
</style>